/////////////////////////////////////////////////V5CommentStart
// 2021-03-14 - No more sliders, pre cleanup
// 2021-03-16 - Big Cleanup
/////////////////////////////////////////////////V5CommentEnd 
import React from 'react'
import classNames from 'classnames'
import 'react-input-range/lib/css/index.css'
import './FormRangeSelector.css'
import {
    FormControl
} from 'react-bootstrap';


export default class FormRangeSelector extends React.PureComponent 
{

    //---------------------------------------
    // not sure whats really needed from parent
    //---------------------------------------
    handleChange = event => 
    {
        const {
            target: {
                name,
                value
            }
        } = event;

        //ddfix, do we need this var at all
        const selectedValue = value;

        this.props.onChange({
            name,
            selectedValue
        });
    }

    //---------------------------------------
    /* 
        0,5000,10000,15000,20000,25000,30000,35000,40000,45000,50000,55000,60000,65000,70000,80000,90000,100000,120000,140000,160000,180000,200000
        
        Array position - key value - displayvalue -> purpose
        pos 0 - 0    -  ALL -> 
        pos 1 - 1000 -  0   -> is anything > 0
        pos n - 5m   -  max -> ( need to change this in api as well) 
    
        Use cases 
        0) no values selected
        1) two numbers min to max selected
        2) max / min reversed
        3) no zero
        4) max value
        5**) 0 to 4 loaded and set from url
        ??  all cars with prices in to/from not working right only shows 1000's
        */
    //---------------------------------------
    buildPriceOptionsArray = (key) => 
    {
        const optimzedPriceBrackets = [5000,10000,15000,20000,25000,30000,35000,40000,45000,50000,55000,60000,65000,70000,80000,90000,100000,120000,140000,160000,180000,200000]

        const options = [
            (
            <option key={ `${ key }-all` } value={0}>
                All Cars (inc Missing Prices)
            </option>
            ) 
            ,
            (
                <option key={ `${ key }-nonZero` } value={1000}>
                    All Cars with Prices 
                </option>
            )    
        ];/// not sure what key is doing there wtf nonZero

        for (let count = 0, fromPriceBracketValue; count < optimzedPriceBrackets.length; count++) 
        {
            fromPriceBracketValue = optimzedPriceBrackets[count];
            options.push((
                <option key={ `${ key }-${ fromPriceBracketValue }` } value={ fromPriceBracketValue }>
                    ${ fromPriceBracketValue.toLocaleString() }
                </option>
            ));

        }
        if (key == 'to-price')
        {
            options.push((
            <option key={ `${ key }-${ 5000000 }` } value={ 5000000}>
                No Limit
            </option>
         ));
        }

        return options;
    }

    //---------------------------------------
    // 
    //---------------------------------------
    buildPriceRangeControls = () => {
        const {
            value
        } = this.props
        //ddfix... do you need these above

        let  newFromPrice = 0
        let  newToPrice   = 0

        if (value)
        {
           newFromPrice = value.min
           newToPrice   = value.max
        }
        //ddfix, was !value, do we need that case
        const fromOptions = this.buildPriceOptionsArray('from-price');
        const toOptions   = this.buildPriceOptionsArray('to-price'  );
  

         return (
            <div>
                <FormControl
                    title="Filter by min price"
                    componentClass="select"
                    name="fromPrice"
                    placeholder="All"
                    onChange={ this.handleChange }
                    //value={ fromPrice }
                    value={ newFromPrice }
                >
                    {fromOptions}
                </FormControl>

                <p className="to">
                    to
                </p>

                <FormControl
                    title="Filter by max price"
                    componentClass="select"
                    name="toPrice"
                    placeholder="All"
                    onChange={ this.handleChange }
                    value={ newToPrice }
//                    value={ price }
                >
                    {toOptions}
                </FormControl>
            </div>
        );
    }

    //---------------------------------------
    // 
    //---------------------------------------
    buildOptions = (key, minValue, maxValue) => {
        const choices = maxValue / 10;

        let from = minValue;
        let to = choices;

        const options = [(
            <option key={ `${ key }-all` }>
                All
            </option>
        )];

        for (let count = 1; count < 10; count++) {
            options.push((
                <option key={ `${ key }-${ count }` } value={ from }>
                    { from }
                </option>
            ));

            from = (to * count);
        }

        return options;
    }

    //---------------------------------------
    // 
    //---------------------------------------
    buildMileageOptionsArray = (key) => 
    {
        const optimzedMileageBrackets = [5000,10000,15000,20000,25000,30000,35000,40000,45000,50000,55000,60000,65000,70000,80000,90000,100000,120000,140000,160000,180000,200000]

        const options = [
            (
            <option key={ `{ key }-all` } value={0}>
                All Cars (inc Missing Miles)
            </option>
            ) 
            ,
            (
                <option key={ `{ key }-nonZero` } value={1000}>
                    All Cars with Miles 
                </option>
            )    
        ];/// not sure what key is doing there  nonZero

        for (let count = 0, fromMileageBracketValue; count < optimzedMileageBrackets.length; count++) 
        {
            fromMileageBracketValue = optimzedMileageBrackets[count];
            options.push((
                <option key={ `{ key }-{ fromMileageBracketValue }` } value={ fromMileageBracketValue }>
                    { fromMileageBracketValue.toLocaleString() }
                </option>
            ));

        }
        if (key == 'to-mileage')
        {
            options.push((
            <option key={ `{ key }-{ 5000000 }` } value={ 5000000}>
                No Limit
            </option>
         ));
        }

        return options;
    }


    //---------------------------------------
    // 
    //---------------------------------------
    buildMileageRangeControls = () => {
        const {
            value
        } = this.props

        let  newFromMileage = 0
        let  newToMileage   = 0

        if (value)
        {
           newFromMileage = value.min
           newToMileage   = value.max
        }

        const fromOptions = this.buildMileageOptionsArray('from-mileage');
        const toOptions   = this.buildMileageOptionsArray('to-mileage');

        return (
            <div>
                <FormControl
                    title="Filter from mileage"
                    componentClass="select"
                    name="fromMileage"
                    placeholder="All"
                    onChange={this.handleChange}
                    value={newFromMileage}
                >
                    {fromOptions}
                </FormControl>

                <p className="to">
                    to
                </p>

                <FormControl
                    title="Filter to mileage"
                    componentClass="select"
                    name="toMileage"
                    placeholder="All"
                    onChange={this.handleChange}
                    value={newToMileage}
                   
>                    {toOptions}
                </FormControl>

            </div>
        );
    }

    //---------------------------------------
    // used to get from/to year and min/max passed... not relevant if not generic
    // options are built directly in here
    //---------------------------------------
    buildYearRangeControls = () => {
        const {
            fromYear,
            toYear,
            minValue,
            maxValue,
            value
        } = this.props

        // maybe could have used passed in value. not worth the effort to be clever    
        // passing state a bit different without redux
        let  newFromYear = 0
        let  newToYear  = 0

        if (value)
        {
           newFromYear = value.min
           newToYear   = value.max
        }
        //ddfix, was !value, do we need that case
        const fromOptions = [(
            <option key="from-year-all" value={0}>
                All
            </option>
        )];

        const toOptions = [(
            <option key="to-year-all" value={2024}>
                All
            </option>
        )];

        for (let year = minValue; year <= maxValue; year++) {
            fromOptions.push((
                <option key={`from-${year}`}
                    value={ year }
                >
                    { year }
                </option>
            ));
        }

        for (let year = maxValue; year > minValue; year--) {
            toOptions.push((
                <option key={`to-${year}`}
                    value={ year }
                >
                    { year }
                </option>
            ));
        }

        return (
            <div>
                <FormControl
                    title="Filter from year"
                    componentClass="select"
                    name="fromYear"
                    placeholder="All"
                    onChange={this.handleChange}
                    value={newFromYear}
                >
                    {fromOptions}
                </FormControl>

                <p className="to">
                    to
                </p>

                <FormControl
                    title="Filter to year"
                    componentClass="select"
                    name="toYear"
                    placeholder="All"
                    onChange={this.handleChange}
                    value={newToYear}
                >
                    {toOptions}
                </FormControl>
            </div>
        );
    }

    //---------------------------------------
    // 
    //---------------------------------------
    render() 
    {
        const {
            unit
        } = this.props
        //  ddfix. how is this triggered, can they make this worse?
        const options = unit === 'dollar'
            ? this.buildPriceRangeControls()
            : unit === 'year'
                ? this.buildYearRangeControls()
                : unit === 'mile'
                    ? this.buildMileageRangeControls()
                    : '';
        
        return (
            <div
                className={classNames(
                    'FormRangeSelector form-group',
                    this.props.className
                )}
            >
                {options}
            </div>
        
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormRangeSelector.js